import { useDispatch, sendFlashMessage } from "@/shared/components/flash"
import { AUTH_SELECT_PROGRAM_TREE } from "@/containers/App/auth";
const INHERIT_SETTINGS_SCHEDULED_AWARD_ENABLED = true;
const DEFAULT_MSG_PARTICIPANT = "Thank you";

export const DEFAULT_CURRENCY = {value: 'USD', label: 'USD', code: 'USD', country_id: 223, symbol:'$', conversion_rate: '1.0000'}

export const flashDispatch = useDispatch
export const flashMessage = sendFlashMessage

export const isProgramManager = (user) => {
  if (user.isManager) return true
  return false
}
export const isProgramParticipant = (user) => {
  if (user.isParticipant) return true
  return false
}
export const isAdmin = (user) => {
  if (user.isAdmin) return true
  return false
}
export const isSuperAdmin = (user) => {
  if (user.isSuperAdmin) return true
  return false
}
export const isEmpty = (object) => { for (var i in object) { return false; } return true; }
export const isObject = function (a) {
  return (!!a) && (a.constructor === Object);
};
export const labelizeNamedData = (data, fields = ["id", "name"]) => {
  if (!data) return null
  let newData = []
  for (var i in data) {
    newData.push({ label: String(data[i][fields[1]]), value: String(data[i][fields[0]]), description: data[i]?.description || ""})
  }
  return newData;
}
export const patch4Select = (data, field, list, cb) => {
  // console.log(list)
  if (typeof data[field] === 'object') return data //in case it is already patched!
  return {
    ...data,
    ...{
      [field]: {
        label: typeof cb === 'function' ? cb(data[field], list) : getLabelByCode(data[field], list),
        value: String(data[field])
      }
    }
  }
}
export const unpatchSelect = (values, fields, renameFields = null) => {
  let clean = {}
  fields.map((field, i) => {
    const fieldName = renameFields && renameFields[i] !== undefined && renameFields[i] ? renameFields[i] : field
    clean[fieldName] = values?.[field]?.value
  })
  return { ...values, ...clean }
}
export const getLabelByCode = (value, list) => {
  return list.find(item => String(item.value) === String(value))?.label
}
export const dateStrToYmd = dateString => {
  //   const userTimezoneOffset = (new Date()).getTimezoneOffset() * 60000;
  //   let date = new Date( dateString )
  //   date = new Date(date.getTime() - userTimezoneOffset).toISOString();
  //   return date.split('T')[0]
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // month is 0-based
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export const hasRoleInProgram = (roleName, programId, user) => {
  if (!user || !user?.programRoles || user?.programRoles.length <= 0) return;
  for (var i in user.programRoles) {
    const programRole = user.programRoles[i] ? user.programRoles[i] : null
    // console.log(programRole)
    // console.log(programId)
    if (programRole && programId) {
      if (programRole.id === programId) {
        // console.log(programRole)
        if (!programRole?.roles || programRole.roles.length <= 0) return false;
        for (var j in programRole.roles) {
          const userRole = programRole.roles[j] ? programRole.roles[j] : null
          if (!userRole) {
            return false;
          }
          if (userRole.name === roleName) return true;
        }
      }
    }
  }
  return false;
}

export const BuildProgramOptions = ({ programs, depth = 0 }) => {
  let optionsHtml = []
  if (programs.length > 0) {
    programs.map(p => {
      optionsHtml.push(<option key={`program-option-${p.id}`} value={`${p.id}`}>{'-'.repeat(depth)} {p.name}</option>)
      if (p?.children && p.children.length > 0) {
        depth++;
        optionsHtml.push(<BuildProgramOptions key={`program-option-group-${p.id}`} programs={p.children} depth={depth} />)
        depth--;
      }
    })
  }
  return optionsHtml
}

export const makeLabelizedOptionsFromTree = (programs, depth = 0) => {
  let optionsObject = []
  if (programs.length > 0) {
    programs.map(p => {
      optionsObject.push({
        label: '-'.repeat(depth) + ' ' + p.name,
        value: p.id
      })
      if (p?.children && p.children.length > 0) {
        depth++;
        optionsObject = [...optionsObject, ...makeLabelizedOptionsFromTree(p.children, depth)]
      }
    })
  }
  return optionsObject
}

function arrayCompare(a1, a2) {
  if (a1.length != a2.length) return false;
  var length = a2.length;
  for (var i = 0; i < length; i++) {
    if (a1[i] !== a2[i]) return false;
  }
  return true;
}

export const inArray = (needle, haystack) => {
  if (!haystack || typeof haystack === 'undefined') return;
  var length = haystack.length;
  for (var i = 0; i < length; i++) {
    if (typeof haystack[i] == 'object') {
      if (arrayCompare(haystack[i], needle)) return true;
    } else {
      if (haystack[i] == needle) return true;
    }
  }
  return false;
}

export const mapFormDataUploads = (values, multiple = false) => {
  let data = new FormData()
  for (const [key, value] of Object.entries(values)) {
    // console.log(value)
    // console.log(typeof value)
    if (value && typeof value === 'object') {
      if (multiple) {
        value.map(itemValue => {
          data.append(`${key}[]`, itemValue)
        })
      } else {
        data.append(key, value[0])
      }
    } else {
      data.append(key, value)
    }
  }
  return data
}

export const unpatchMedia = (dataset, fields) => {
  if (!dataset || !fields) return dataset;
  for (const [key, value] of Object.entries(dataset)) {
    if (inArray(key, fields) && (typeof value === 'string' || value === null)) {
      delete dataset[key]
    }
  }
  return dataset
}

export const patchMediaURL = (dataset, fields) => {
  if (!dataset || !fields) return dataset;
  for (const [key, value] of Object.entries(dataset)) {
    if (inArray(key, fields) && value && value.indexOf(process.env.REACT_APP_API_STORAGE_URL) === -1) {
      dataset[key] = `${process.env.REACT_APP_API_STORAGE_URL}/${value}`
    }
  }
  return dataset
}

export const prepareRequestParams = (filter, fields) => {
  const params = []
  let paramStr = ''
  if (filter) {
    fields.map((field) => (filter[field] !== 'undefined' && filter[field]) ? params.push(field + `=${filter[field]}`) : null);
    paramStr = params.join('&')
  }
  return paramStr;
}

export const validEmail = (email) => {
  return /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/i.test(email)
}

export const createMarkup = (value) => {
  return { __html: value };
}

export const getFirstDay = () => {
  let date = new Date();
  return new Date(date.getFullYear(), 0, 1)
}

const getResponseHeaderValue = (headers, headerName) => {
  if (!headers || !headerName) return null
  const headerKey = Object.keys(headers).find(
    (key) => String(key).toLowerCase() === String(headerName).toLowerCase()
  )
  return headerKey ? headers[headerKey] : null
}

const parseDownloadMessage = (payload, fallbackMessage) => {
  if (!payload) return fallbackMessage

  if (typeof payload === 'string') {
    try {
      const parsed = JSON.parse(payload)
      return parseDownloadMessage(parsed, fallbackMessage)
    } catch (e) {
      return payload.trim() || fallbackMessage
    }
  }

  if (Array.isArray(payload)) {
    const joined = payload
      .map((item) => parseDownloadMessage(item, ''))
      .filter(Boolean)
      .join(', ')
    return joined || fallbackMessage
  }

  if (typeof payload === 'object') {
    return (
      payload.message ||
      payload.error ||
      parseDownloadMessage(payload.errors, '') ||
      parseDownloadMessage(Object.values(payload), fallbackMessage)
    )
  }

  return fallbackMessage
}

const readDownloadPayloadText = async (payload) => {
  if (!payload) return ''
  if (payload instanceof Blob) return payload.text()
  if (payload instanceof ArrayBuffer) return new TextDecoder().decode(payload)
  if (typeof payload === 'string') return payload
  if (typeof payload === 'object') return JSON.stringify(payload)
  return ''
}

export const extractDownloadErrorMessage = async (
  error,
  fallbackMessage = 'Download failed.'
) => {
  const responseData = error?.response?.data

  if (responseData) {
    const text = await readDownloadPayloadText(responseData)
    if (text) {
      return parseDownloadMessage(text, fallbackMessage)
    }
  }

  return error?.message || fallbackMessage
}

export const getDownloadFilename = (headers, fallbackFilename = 'download') => {
  const contentDisposition = getResponseHeaderValue(headers, 'content-disposition')
  if (!contentDisposition) return fallbackFilename

  const utf8Match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim())
    } catch (e) {
      return utf8Match[1].trim()
    }
  }

  const filenameMatch = contentDisposition.match(/filename\s*=\s*"?(.*?)"?(?:;|$)/i)
  if (filenameMatch?.[1]) {
    return filenameMatch[1].trim()
  }

  return fallbackFilename
}

export const downloadBinaryResponse = async (
  response,
  fallbackFilename,
  { expectPdf = false, fallbackMimeType = 'application/octet-stream' } = {}
) => {
  const contentType =
    getResponseHeaderValue(response?.headers, 'content-type') ||
    response?.data?.type ||
    fallbackMimeType

  const blob =
    response?.data instanceof Blob
      ? response.data
      : new Blob([response?.data], { type: contentType })

  if (expectPdf) {
    const pdfHeader = await blob.slice(0, 5).text().catch(() => '')
    if (pdfHeader !== '%PDF-') {
      const text = await readDownloadPayloadText(blob)
      throw new Error(
        parseDownloadMessage(text, 'The downloaded invoice summary is not a valid PDF.')
      )
    }
  }

  const filename = getDownloadFilename(response?.headers, fallbackFilename)
  const objectUrl = window.URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = objectUrl
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()

  window.setTimeout(() => {
    window.URL.revokeObjectURL(objectUrl)
  }, 1000)

  return filename
}

export const getFirstDayOfMonth = () => {
  let date = new Date();
  return new Date(date.getFullYear(), date.getMonth(), 1)
}

export const getLastDayOfMonth = () => {
  let date = new Date();
  return new Date(date.getFullYear(), date.getMonth() + 1, 0)
}

export const indexOfAll = (array, searchItem) => {
  let i = array.indexOf(searchItem),
    indexes = [];
  while (i !== -1) {
    indexes.push(i);
    i = array.indexOf(searchItem, ++i);
  }
  return indexes;
}

export const toCurrency = (numberString) => {
  if (numberString === undefined) return '';
  let locale = 'en-US';
  let options = { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 };
  let formatter = new Intl.NumberFormat(locale, options);
  return formatter.format(numberString);
}

export const toPoints = (numberString) => {
  let locale = 'en-US';
  let options = { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 3 };
  let formatter = new Intl.NumberFormat(locale, options);
  let number = formatter.format(numberString);
  return number.toString().replace(/\./g, ",");
}

export const showPercentage = (numberString) => {
  let locale = 'en-US';
  let options = { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 };
  let formatter = new Intl.NumberFormat(locale, options);
  return formatter.format(numberString);
}

export const cacheProgramTree = (tree) => {
  localStorage.setItem(AUTH_SELECT_PROGRAM_TREE, JSON.stringify(tree));
}

export const getCachedProgramTree = () => {
  const cachedTreeStr = localStorage.getItem(AUTH_SELECT_PROGRAM_TREE);
  if (cachedTreeStr) {
    return JSON.parse(cachedTreeStr)
  }
}

export const isValidUrl = urlString => {
  try {
    return Boolean(new URL(urlString));
  }
  catch (e) {
    return false;
  }
}

export const isBadgeAward = (event_type_id) => {
  let type_to_match = event_type_id
  if (isObject(event_type_id) && typeof event_type_id.value !== 'undefined') {
    type_to_match = event_type_id.value
  }
  return type_to_match == 5 //badge
    || type_to_match == 6 //peer to peer badge
    || type_to_match == 10 //miglestone badge
    || type_to_match == 12 //Birthday Badge
    || type_to_match == 15 //Anniversary Badge
}

export const isMilestoneAward = (event_type_name) => {
  return event_type_name === "Milestone Badge" //badge
    || event_type_name === "Milestone Award"
}

export const isCustomAward = (event_type_id) => {
  let type_to_match = event_type_id
  if (isObject(event_type_id) && typeof event_type_id.value !== 'undefined') {
    type_to_match = event_type_id.value
  }
  return type_to_match == 13
}

export function getFormattedDate(date) {
  var year = date.getFullYear();
  var month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : '0' + month;
  var day = date.getDate().toString();
  day = day.length > 1 ? day : '0' + day;
  return month + '/' + day + '/' + year;
}

export const isScheduledAwardEnabled = (rootProgram, program, event = null) => {
  if (program.enable_schedule_awards || program.schedule_awards_required) {
    return true;
  }
  if (INHERIT_SETTINGS_SCHEDULED_AWARD_ENABLED && (rootProgram.enable_schedule_awards || rootProgram.schedule_awards_required)) {
    return true;
  }
  if (event && event?.enable_schedule_award) {
    return true;
  }
  return false;
}

export const isScheduledAwardRequired = (rootProgram, program) => {
  if (program.schedule_awards_required) {
    return true;
  }
  if (INHERIT_SETTINGS_SCHEDULED_AWARD_ENABLED && rootProgram.schedule_awards_required) {
    return true;
  }
  return false;
}

export const isCascadingApprovalsEnabled = (rootProgram) => {
  if (
    rootProgram.use_cascading_approvals
  ) {
    return true;
  }
  return false;
};

export const isSaveToHierarchyEnabled = (rootProgram, program) => {
  if (program?.allow_save_to_hierarchy || rootProgram?.allow_save_to_hierarchy) {
    return true;
  }
  return false;
};

/**
 * Currently Scion-only — Scion is the only program with uses_entrata_pending_approvals=1.
 * Rename if other Entrata clients are onboarded.
 *
 * IMPORTANT: callers must pass `program.rootProgram` (the BE-hydrated nested
 * root subset from DomainController / ProgramController). Do NOT pass
 * `state.rootProgram` — that redux slice is populated from `data.program` on
 * login and is actually the scoped/picked program, not the hierarchy root
 * (the slice name is a 2022 misnomer). For subprogram-scoped managers,
 * `state.rootProgram.uses_entrata_pending_approvals` is 0 — predicate
 * silently fails. See ICOV3-1540 continuation arc 2 spec for full context.
 *
 * Uses optional chaining: program.rootProgram can be momentarily undefined
 * during impersonation transitions; sibling helpers above don't guard against this.
 */
export const isScionProgram = (rootProgram) => {
  if (
    rootProgram?.uses_entrata_pending_approvals === 1
  ) {
    return true;
  }
  return false;
};

export const isBudgetEnabled = (rootProgram) => {
  if (
    rootProgram.use_budget_cascading ||
    rootProgram.budget_summary
  ) {
    return true;
  }
  return false;
};

export const v3SetCookie = (name, value, days) => {
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + days);

  document.cookie = `${name}=${value}; expires=${expirationDate.toUTCString()}; path=/`;
};

export const v3GetCookie = (name) => {
  const cookies = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`));

  return cookies ? cookies.split("=")[1] : null;
};

export const v3DeleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};
//dateToUSFormat function is used strictly to convert for format mysql date string, for example "2025-12-23" to US format, "12/23/2025" only. DO NOT use this function to use other "display" date strings.
export const dateToUSFormat = (dateString) =>{
  if (dateString && !isNaN(new Date(dateString))) {
    const indexOfT = dateString.indexOf('T')
    if (indexOfT > 0) {
      //A date string with timezone has something like 2017-06-23T00:33:06.000000Z to it is safe to check dateString.indexOf T > 0 and add timezone part
      dateString = dateString.substring(0, indexOfT)
    }
    const [year, month, day] = dateString.split("-");
    return `${month}/${day}/${year}`
  }
}

export const amountToUsFormat = (
    amount,
    isFraction = true,
    currency = "",
    fractionDigits = { minimumFractionDigits: 2, maximumFractionDigits: 2 }
  ) => {
    if (!Number.isFinite(amount)) return "";
  
    let formattedAmount = amount.toLocaleString("en-US", isFraction ? fractionDigits : { 
      minimumFractionDigits: 0, 
      maximumFractionDigits: 0 
    });
    return currency ? `${currency}${formattedAmount}` : formattedAmount;
}

export const getRedemptionValue = (item, merchant) => {
  // console.log("typeof", typeof item.sku_value)
  const useVirtualRedemptionValue = parseFloat(item.virtual_redemption_value) > parseFloat(item.sku_value)
  const value = merchant?.cost_to_program ? item.sku_value : (item.is_premium ? (useVirtualRedemptionValue ? item.virtual_redemption_value : item.redemption_value) : item.sku_value);
  return value;
}

export const getCartTotalPointsOrDollars = (items = [], fc, redemptionValues,is_dollar) => {
  return items.reduce((total, item, index) => {
    const redemption_value =redemptionValues[index] ?? 0;
    const multiplier = !is_dollar ? fc : 1;
    return total + redemption_value * multiplier * item.qty;
  }, 0)
}

export const labelizeNamedRow = (row, fields = ["id", "name"]) => {
  if(typeof row[fields[0]] !== 'undefined' && typeof row[fields[1]] !== 'undefined')
  {
      return {...row, ...{value: String(row[fields[0]]), label: String(row[fields[1]])}}
  }
  return row
}

export const renameChildrenToSubrows = data => {
  // console.log(data)
  
  if( !data || (typeof data == 'object' && data.length == 0) ) return data;
  // console.log(data)
  let newData = []
  data.map( row => {
      let newRow = refit_keys( row )
      newData.push( newRow )
  })
  return newData;
}

function refit_keys(o){
  var build, key, destKey, value;
  if (o === null || typeof o !== "object") {
      return o;
  }
  if (Array.isArray(o)) {
      return o.map(refit_keys);
  }
  build = {};
  for (key in o) {
      destKey = mapChildrenToSubrows[key] || key;
      value = o[key];
      if (typeof value === "object") {
          value = refit_keys(value);
      }
      build[destKey] = value;
  }
  return build;
}

export const objectToUrlParams = (obj) => {
  const params = [];
  for (const key in obj) {
    params.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
  }
  return params.join('&');
}

export const labelizeData = (data) => {
  let newData = []
  for( var i in data) {
      newData.push({label: String(data[i]), value: i})
  }
  return newData;
}
export const removeFields = ( dataset, fields ) => {
  if( !dataset || !fields ) return dataset;
  for (const [key, value] of Object.entries(dataset)) {
      if( inArray(key, fields) )  {
          delete dataset[key]
      }
  }
  return dataset
}

 // Object with no prototype to avoid false matches on `toString` and other built-ins
 var mapChildrenToSubrows = Object.assign(Object.create(null), {
  "children": "subRows"
});

export const ifElseKeyValue = (obj, ifKey, elseKey) => {
  return (ifKey in obj && obj[ifKey]) ? obj[ifKey] : (elseKey in obj && obj[elseKey] ? obj[elseKey]: null)
};

export const ifV2elseV3AccountHolderId = ( program ) => {
  return ifElseKeyValue(program, "v2_account_holder_id", "account_holder_id")
}

export const normalizeScalarValue = (value) => {
  if (Array.isArray(value)) {
    return normalizeScalarValue(value[0])
  }

  if (value && typeof value === 'object') {
    if ('value' in value) return normalizeScalarValue(value.value)
    if ('id' in value) return normalizeScalarValue(value.id)
    return null
  }

  return value ?? null
}

export function buildIdArray( object )    {
  let idArray = []
  for(var i in object)    {
      idArray.push( object[i].id );
  }
  return idArray
}

export const hasSmsablePhoneNumber = (user) => {
  if( !user.phone ) return false;
  if( user.phone === '0000000000' || user.phone === '1111111111') return false;
  if( !user.country_code && user.phone.indexOf('+') === -1 ) return false;
  return true;
}
export const prepareUrlByDomain = (domain) => {

    if( process.env.REACT_APP_BASE_URL.indexOf('local') === -1 ) {
        //This is not the safest way to check for production env but we can try it as it is "local" 99% times. Update this function if you have different domain name for your "local" admin app
        domain.scheme = 'https'
    }

    return `${domain.scheme}://${domain.name}${domain.port ? `:${domain.port}` : ''}/loginAs`;
}

export const dobDisplay = (dob) => {
  if (dob){
      return dob.slice(5);
  }
  return dob;
}

export const isForeignCurrency = (currency) => {
  return currency.code !== DEFAULT_CURRENCY.code
}

export const getReportName = (baseName) => {
  const today = new Date();
  return `${baseName}_${dateStrToYmd(today)}.csv`;
};
export const numberDecimalRound = (value) => {
  const num = Number(value);
  return isNaN(num) ? 0 : parseFloat(num).toFixed(2);
};

export const normalizeRichTextMessage = (message) => {
  return String(message || "")
    .replace(/&nbsp;/gi, " ")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export const getAwardMessage = (item, fallback = DEFAULT_MSG_PARTICIPANT) => {
  if (!item) return "";
  const normalized = normalizeRichTextMessage(item.message);
  return !item.award_message_editable && !normalized
    ? fallback
    : item.message;
};
export const formatFloatValue = (value) => {
    const num = parseFloat(value);
    
    // Return 0 or fallback if the input is malformed or empty
    if (isNaN(num)) return '0';

    // Check if the value has a fractional/decimal portion
    return num % 1 !== 0 ? num.toFixed(2) : String(Math.floor(num));
};

/**
 * Flattens any incoming API error structure (String, Array, or validation Object)
 * into a single clean readable message.
 */
export const formatApiErrors = (errors) => {
    if (!errors) return "An unexpected validation error occurred.";
    
    if (typeof errors === 'string') return errors;
    
    if (Array.isArray(errors)) {
        return errors.join(', ');
    }
    
    if (typeof errors === 'object') {
        return Object.values(errors)
            .flat() // flattens arrays inside properties seamlessly
            .join(', ');
    }
    
    return "Submission failed.";
};